import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type { TListPartnerSecurityDocumentsResponse } from "./listPartnerSecurityDocuments.jsonschema";

export interface IListPartnerSecurityDocumentsParams {
  partner_id: string;
  accessToken: string;
}

export const listPartnerSecurityDocuments = (axios: IAxiosInstance) => {
  return async (
    params: IListPartnerSecurityDocumentsParams
  ): Promise<TListPartnerSecurityDocumentsResponse> => {
    const { partner_id, accessToken } = params;
    const response = await axios.noRetry.get<
      IApiResponse<TListPartnerSecurityDocumentsResponse>
    >(`/api/partners/${partner_id}/security-documents`, {
      params: { accessToken },
    });
    const resData = response.data;
    if (resData?.success && resData.data) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
